import Typography from '@anwb/poncho/components/typography';

import { LeadDisclaimerContainer } from '../../RequestFlow.styled';

export const LeadDisclaimer = () => (
	<LeadDisclaimerContainer id="lead-disclaimer-container">
		<Typography variant="body-text" id="lead-disclaimer-text">
			Een aanvraag is <strong>vrijblijvend</strong> en <strong>zonder kosten</strong>
		</Typography>
	</LeadDisclaimerContainer>
);
